__turbopack_context__.v({
  "bundleChevronAttention": "bundle-selector-module__1EDk5G__bundleChevronAttention",
  "bundleCompanionAction": "bundle-selector-module__1EDk5G__bundleCompanionAction",
  "bundleCompanionButton": "bundle-selector-module__1EDk5G__bundleCompanionButton",
  "bundleCompanionContent": "bundle-selector-module__1EDk5G__bundleCompanionContent",
  "bundleCompanionIcon": "bundle-selector-module__1EDk5G__bundleCompanionIcon",
  "bundleCompanionProductName": "bundle-selector-module__1EDk5G__bundleCompanionProductName",
  "bundleCompanionProducts": "bundle-selector-module__1EDk5G__bundleCompanionProducts",
  "bundleComparePrice": "bundle-selector-module__1EDk5G__bundleComparePrice",
  "bundleContainer": "bundle-selector-module__1EDk5G__bundleContainer",
  "bundleDividerLine": "bundle-selector-module__1EDk5G__bundleDividerLine",
  "bundleFinalPrice": "bundle-selector-module__1EDk5G__bundleFinalPrice",
  "bundleHeader": "bundle-selector-module__1EDk5G__bundleHeader",
  "bundleInfo": "bundle-selector-module__1EDk5G__bundleInfo",
  "bundleName": "bundle-selector-module__1EDk5G__bundleName",
  "bundleNameRow": "bundle-selector-module__1EDk5G__bundleNameRow",
  "bundleOption": "bundle-selector-module__1EDk5G__bundleOption",
  "bundleOptionDefault": "bundle-selector-module__1EDk5G__bundleOptionDefault",
  "bundleOptionDisabled": "bundle-selector-module__1EDk5G__bundleOptionDisabled",
  "bundleOptionHeader": "bundle-selector-module__1EDk5G__bundleOptionHeader",
  "bundleOptionHitArea": "bundle-selector-module__1EDk5G__bundleOptionHitArea",
  "bundleOptionLeft": "bundle-selector-module__1EDk5G__bundleOptionLeft",
  "bundleOptionRight": "bundle-selector-module__1EDk5G__bundleOptionRight",
  "bundleOptionSelected": "bundle-selector-module__1EDk5G__bundleOptionSelected",
  "bundleOptions": "bundle-selector-module__1EDk5G__bundleOptions",
  "bundlePricePerUnit": "bundle-selector-module__1EDk5G__bundlePricePerUnit",
  "bundleProductIcon": "bundle-selector-module__1EDk5G__bundleProductIcon",
  "bundleProductLabel": "bundle-selector-module__1EDk5G__bundleProductLabel",
  "bundleProductText": "bundle-selector-module__1EDk5G__bundleProductText",
  "bundleQuantity": "bundle-selector-module__1EDk5G__bundleQuantity",
  "bundleRadio": "bundle-selector-module__1EDk5G__bundleRadio",
  "bundleSelectorReveal": "bundle-selector-module__1EDk5G__bundleSelectorReveal",
  "bundleTag": "bundle-selector-module__1EDk5G__bundleTag",
  "bundleTitle": "bundle-selector-module__1EDk5G__bundleTitle",
  "menu": "bundle-selector-module__1EDk5G__menu",
  "menuItem": "bundle-selector-module__1EDk5G__menuItem",
  "mostPopularBadge": "bundle-selector-module__1EDk5G__mostPopularBadge",
  "popoverWrap": "bundle-selector-module__1EDk5G__popoverWrap",
  "selectChevron": "bundle-selector-module__1EDk5G__selectChevron",
  "selectChevronAttention": "bundle-selector-module__1EDk5G__selectChevronAttention",
  "selectChevronOpen": "bundle-selector-module__1EDk5G__selectChevronOpen",
  "selectorNote": "bundle-selector-module__1EDk5G__selectorNote",
  "unavailable": "bundle-selector-module__1EDk5G__unavailable",
  "variantSelect": "bundle-selector-module__1EDk5G__variantSelect",
  "variantSelectors": "bundle-selector-module__1EDk5G__variantSelectors",
  "variantSelectorsOpen": "bundle-selector-module__1EDk5G__variantSelectorsOpen",
  "variantSlot": "bundle-selector-module__1EDk5G__variantSlot",
  "variantSlotHeader": "bundle-selector-module__1EDk5G__variantSlotHeader",
  "variantSlotOptions": "bundle-selector-module__1EDk5G__variantSlotOptions",
  "variantTriggerValue": "bundle-selector-module__1EDk5G__variantTriggerValue",
});
